import React from 'react';
import { Card } from '@/components/ui/card';
import { BookOpen, CheckCircle, XCircle, Clock } from 'lucide-react';

interface ResourceStatsProps {
  stats: {
    total: number;
    processed: number;
    successful: number;
    failed: number;
  };
}

export const ResourceStats: React.FC<ResourceStatsProps> = ({ stats }) => {
  const coverage = stats.total > 0 ? Math.round((stats.processed / stats.total) * 100) : 0;
  const pending = stats.total - stats.processed;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Total Modules</p>
            <p className="text-3xl font-bold mt-2">{stats.total}</p>
          </div>
          <BookOpen className="h-10 w-10 text-primary opacity-20" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">With Resources</p>
            <p className="text-3xl font-bold mt-2">{stats.processed}</p>
            <p className="text-xs text-muted-foreground mt-1">{coverage}% coverage</p>
          </div>
          <CheckCircle className="h-10 w-10 text-green-600 opacity-20" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Pending</p>
            <p className="text-3xl font-bold mt-2">{pending}</p>
          </div>
          <Clock className="h-10 w-10 text-amber-600 opacity-20" />
        </div>
      </Card>

      <Card className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Failed</p>
            <p className="text-3xl font-bold mt-2">{stats.failed}</p>
          </div>
          <XCircle className="h-10 w-10 text-red-600 opacity-20" />
        </div>
      </Card>
    </div>
  );
};
